import axios from 'axios';
import * as endPoints from '../../../../Constants/Endpoints'



export function GetServices(shopId) {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ServicesOpen,
    {
        params: {shopId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetConfig() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetConfig,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

// export function GetServiceDurations() {
//     return axios.get(
//         process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ServiceDurations,
//     {
//         headers: {
//             "Content-Type": "application/json"
//         },
//         withCredentials: true
//     });
// }

export function GetActiveBarbers(barberShopId) {
    
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ActiveBarbers,
    {
        params : {barberShopId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetServicesByBarberId(barberId) {
    
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ServicesByBarber,
    {
        params : {barberId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetBarberWorkingDays(barberId, shopId) {
    
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.BarberWorkingDaysOpen,
    {
        params : {barberId, shopId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function AcceptingPaymentsStatus(shopId) {
    
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.AcceptingPaymentsStatus,
    {
        params : {shopId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function CreatePaymentIntent(
    barberId,
    serviceId,
    startTimeId,
    durationTimeBlock,
    firstName,
    lastName,
    email,
    mobile,
    date,
    time) {
        var startDateTime = new Date((new Date(date).setHours(Number((time).split(":")[0]),Number((time).split(":")[1]),0,0)))

        const paymentRequest = {
        barberId,
        serviceId,
        startDateTime,
        startTimeId,
        durationTimeBlock,
        firstName,
        lastName,
        email,
        mobile
    }
    
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.CreatePaymentIntent, paymentRequest,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function CreateBooking(
    barberId,
    serviceId,
    startDateTimeNumber,
    startTimeId,
    durationTimeBlock,
    firstName,
    lastName,
    email,
    mobile,
    sendReminder
    ) {
    const startDateTime = new Date(startDateTimeNumber)
    const customerBookingAppointmentDto = {
        barberId,
        serviceId,
        startDateTime,
        startTimeId,
        durationTimeBlock,
        firstName,
        lastName,
        email,
        mobile,
        sendReminder
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Booking, customerBookingAppointmentDto,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetAvailableTimesForBarberByDateTime(barberId, dateTime, serviceId, shopId) {
    console.log()
    const dayOfWeek = new Date(dateTime).getDay()
    const date = new Date(dateTime)

    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetAvailableTimesForBarberByDateTimeOpen,
    {
        params : {barberId, date, serviceId, dayOfWeek, shopId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetServiceDurations(shopId) {
    console.log(shopId)
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ServiceDurationsOpen,
    {
        params: {shopId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetTermsAndConditions(shopId) {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Terms,
    {
        params: {shopId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetTheme(shopId) {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SiteTheme,
    {
        params: {shopId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetFutureAppointmentsByBarber(barberId) {

    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.FutureAppointments,
    {
        params: {barberId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetBarberWorkingTimes() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.BarberWorkingTimes,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function DeleteBarber(barberId) {
    const barberToDelete = {
        barberId
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.DeleteBarber, barberToDelete,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function DisableBarber(barberId) {
    const barberToDelete = {
        barberId
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.DisableBarber, barberToDelete,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function ActivateBarber(barberId) {
    const barberToDelete = {
        barberId
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ActivateBarber, barberToDelete,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}